import { MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function HoverImage(props) {
  const [image, setImage] = React.useState(props.normalImage);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = props.hoverImage;
  }, [props.hoverImage]);

  const over = (e) => {
    setHovered(!hovered);
  };

  const out = (e) => {
    setHovered(!hovered);
  };

  return (
    <>
      <MenuItem
        onMouseOver={over}
        onMouseOut={out}
        component={Link}
        to={props.link}
        className="profileMenu"
        sx={{
          "&:hover": {
            backgroundColor: "rgba(144, 144, 144, 0.1)",
            "& .MuiTypography-root": {
              color: "#F2824C",
            },
          },
        }}
      >
        <img
          src={hovered ? props.hoverImage : props.normalImage}
          alt={props.alt}
          style={{ paddingRight: "10px" }}
        />
        <Typography
          sx={{
            fontFamily: "font_regular",
            color: props.darkMode ? "rgba(221, 221, 221, 1)" : "#434547",
          }}
        >
          {props.item}
        </Typography>
      </MenuItem>
    </>
  );
}

export default HoverImage;
